import { camelCaseKeys, withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { withCookies } from 'react-cookie';
import { OVERRIDE_LAUNCH_DARKLY_FLAGS_COOKIE_NAME } from '../../../config';
import { isClientSide } from '../../util/system';

/**
 * withCustomLDConsumer is our custom wrapper around withLDConsumer which returns a HOC with flags and the ldClient
 * instance injected via props. The key feature of our HOC is that it allows one to override specific flags using the
 * "override-launch-darkly-flags" - which is useful for testing.
 */
function withCustomLDConsumer() {
  return function wrapWithLDConsumer(WrappedComponent: any) {
    const OverriddenWithLDConsumer = (props: any) => {
      const { cookies } = props;
      const overridenFlags = JSON.parse(
        cookies?.cookies?.[OVERRIDE_LAUNCH_DARKLY_FLAGS_COOKIE_NAME] ?? '{}'
      );

      // Here we are overriding the launch darkly flags with any explicitly set values for the purpose of e2e testing.
      return (
        <WrappedComponent
          {...props}
          flags={{
            ...props?.flags,
            ...(isClientSide() ? camelCaseKeys(overridenFlags) : overridenFlags),
          }}
        />
      );
    };

    // eslint-disable-next-line no-restricted-syntax
    return withLDConsumer()(withCookies(OverriddenWithLDConsumer));
  };
}

export default withCustomLDConsumer;
